import React, { useState, useEffect } from "react";
import Card from "../../components/Card";
import Action from "../../components/Action";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageCatAndHousePlant from "../../images/cat-and-houseplant.png";
import { HIGH_RISK_SECTORS, YES_NO_OPTIONS } from "../../constants";
import RadioQuestion from "../../components/RadioQuestion";

const EmploymentInformation = ({ employmentInformation, onStepComplete }) => {
  const [buyerHandlesCashAtWork, setBuyerHandlesCashAtWork] = useState(null);
  const [buyerHighRiskWorkSectors, setBuyerHighRiskWorkSectors] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (employmentInformation) {
      setBuyerHandlesCashAtWork(employmentInformation.buyerHandlesCashAtWork);
      setBuyerHighRiskWorkSectors(employmentInformation.buyerHighRiskWorkSectors);
    }
  }, [employmentInformation]);

  const handleFieldValidation = (field) => (event) => {
    if (event.type !== "blur") {
      setErrors((prevErrors) => ({ ...prevErrors, [field]: null }));
    } else {
      const fieldValue = {
        buyerHandlesCashAtWork,
        buyerHighRiskWorkSectors,
      }[field];

      if (!fieldValue) {
        setErrors((prevErrors) => ({ ...prevErrors, [field]: true }));
      }
    }
  };

  const handleValidation = () => {
    const newErrors = {};
    let formIsValid = true;

    if (buyerHandlesCashAtWork === null) {
      newErrors.buyerHandlesCashAtWork = true;
      formIsValid = false;
    }

    if (!buyerHighRiskWorkSectors || buyerHighRiskWorkSectors.length === 0) {
      newErrors.buyerHighRiskWorkSectors = true;
      formIsValid = false;
    }

    setErrors(newErrors);

    return formIsValid;
  };

  const saveEmploymentInformation = (event) => {
    event.preventDefault();

    if (handleValidation()) {
      onStepComplete({
        employmentInformation: {
          buyerHandlesCashAtWork,
          buyerHighRiskWorkSectors,
        },
      });
    }
  };

  return (
    <>
      <ScrollToTop />
      <Card title="Tell us about your employment" removeTopPadding>
        <RadioQuestion
          question="Do you work in one of the following sectors?"
          options={HIGH_RISK_SECTORS}
          selected={buyerHighRiskWorkSectors}
          name="buyerHighRiskWorkSectors"
          optionSelected={setBuyerHighRiskWorkSectors}
          validate={handleFieldValidation("buyerHighRiskWorkSectors")}
          validationError={errors.buyerHighRiskWorkSectors ? "Please select an option" : null}
        />

        <RadioQuestion
          question="Do you work for or run a business that handles large amounts of cash?"
          hint="(for example, a Post Office, newsagent, nail technician, restaurant owner)"
          options={YES_NO_OPTIONS}
          inline={true}
          name="buyerHandlesCashAtWork"
          selected={buyerHandlesCashAtWork}
          optionSelected={setBuyerHandlesCashAtWork}
          validate={handleFieldValidation("buyerHandlesCashAtWork")}
          validationError={errors.buyerHandlesCashAtWork ? "Please select an option" : null}
        />

        <Action onClick={saveEmploymentInformation}>Continue</Action>
      </Card>
      <Image src={imageCatAndHousePlant} />
    </>
  );
};

export default EmploymentInformation;
